import React, { useEffect, useState } from "react";
import { CustomInput } from "../../../components/main_comps/custom_input/CustomInput";
import custom_getvalue from "../../../components/main_comps/custom_getvalue";

const Container = ({ title, value }) => {
  return (
    <div style={{ display: "flex", marginBottom: "20px" }}>
      <p
        style={{
          color: "#000000",
          fontSize: "14px",
          fontWeight: "500",
          width: "180px",
        }}
      >
        {title}
      </p>
      <p style={{ color: "#3A3A3A", fontSize: "14px" }}>{value}</p>
    </div>
  );
};

const inputStyle = {
  backgroundColor: "#F3F3F3",
  alignSelf: "center",
  height: 40,
  boxShadow: "none",
  outline: "none",
  paddingLeft: 10,
  boxSizing: "border-box",
  borderRadius: "5px",
  width: "100%",
};
const containerStyle = {
  padding: 0,
  maxWidth: 300,
  minWidth: "250px",
  width: "100%",
  height: "40px",
};

const BasicDetails = ({ data, isEditClicked = false, onChange }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");

  useEffect(() => {
    onChange({
      firstName: custom_getvalue(firstName, data?.firstName),
      lastName: custom_getvalue(lastName, data?.lastName),
      email: custom_getvalue(email, data?.email),
      mobileNumber: custom_getvalue(mobileNumber, data?.mobileNumber),
    });
  }, [firstName, lastName, email, mobileNumber]);

  useEffect(() => {
    setFirstName(data?.firstName);
    setLastName(data?.lastName);
    setEmail(data?.email);
    setMobileNumber(data?.mobileNumber);
  }, [isEditClicked, data]);
  return (
    <div
      style={{
        padding: "10px 20px",
        flexWrap: "wrap",
        display: "flex",
        flexDirection: "row",
      }}
    >
      {isEditClicked ? (
        <>
          <div style={{ width: "50%", minWidth: "400px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#000000",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "180px",
                }}
              >
                {"First Name"}
              </p>
              <CustomInput
                value={firstName}
                onChange={(data) => setFirstName(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="First Name"
                validator="name"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#000000",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "180px",
                }}
              >
                {"Last Name"}
              </p>
              <CustomInput
                value={lastName}
                onChange={(data) => setLastName(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Last Name"
                validator="name"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#000000",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "180px",
                }}
              >
                {"Email Id"}
              </p>
              <CustomInput
                value={email}
                onChange={(data) => setEmail(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Email id"
                validator="email"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#000000",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "180px",
                }}
              >
                {"Mobile number"}
              </p>
              <CustomInput
                value={mobileNumber}
                onChange={(data) => setMobileNumber(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Mobile number"
                validator="mobile"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
          </div>
        </>
      ) : (
        <div style={{ padding: "10px 20px" }}>
          <Container
            title="Name:"
            value={data?.firstName + " " + data?.lastName}
          />
          <Container title="Email ID:" value={data?.email} />
          <Container
            title="Mobile Number:"
            value={"+91 " + data?.mobileNumber}
          />
        </div>
      )}
    </div>
  );
};

export default BasicDetails;
